/**
 * @desc 批量下载报关单
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.ExportDeclarationDownloadResponseDto>;
export function request(
  body: defs.tms.ExportDeclarationRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/exportDeclaration/downloadExportDeclarationList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
